module.exports = __webpack_public_path__ + "img/home_adapt_vertical_up_disabled.554bb01b.svg";